import React, { useState } from 'react'
import ReactModal from 'react-modal'
import Checkbox from 'src/components/Checkbox'
import { useOffer } from 'src/hooks/offer'
import { FC_FLOW_PRE_URL } from '../../../../../services/api'
import { Button } from '../styles'
import {
	CloseButton,
	Container,
	Line,
	Link,
	ModalHeader,
	Terms,
	TextBlock
} from './styles'
import { eventTrack } from 'src/components/GoogleTagManager'

function Footer({ buttonColor, terms, textColor, modalOpen, cupons }) {
	const [checked, setChecked] = useState(false)
	const [openModal, setOpenModal] = useState(false)
	// eslint-disable-next-line
	const { currentOffer } = useOffer()

	console.log(terms);
	return (
		<>
			<Container blur={modalOpen}>
				{/* <p style={{ color: '#685E58', lineHeight: '18px' }}>Oferta válida até {validade}</p> */}
				<Terms isChecked={checked}>
					<Checkbox
						id="check-term"
						disabled={modalOpen}
						onChange={() => {
							setChecked(!checked);
							eventTrack(
								'veloe:institucional',
								'interacao:checkbox',
								'check-term:' + String(!checked)
							);
						}}
						className="termoAceite"
					/>
					<label htmlFor="check-term">
						Estou ciente que, ao prosseguir, aceito o{" "}
						<b onClick={(e) => {
							e.preventDefault()
							setOpenModal(true)
						}}>regulamento</b> da
						campanha.
					</label>
				</Terms>
				<div className="botoesCupons">
					<Link
						disabled={!checked}
						href={!checked ? "" : `${FC_FLOW_PRE_URL}?origem=lp&codigo=${cupons[0]}`}
					>
						<Button
							background='#CC092F' color='#fff'
							disabled={!checked}
							onClick={() => eventTrack(
								'veloe:institucional',
								'clique:botao',
								'planos:peca-ja'
							)}
						>
							Peça já
						</Button>
					</Link>
				</div>
			</Container>
			<ReactModal isOpen={openModal} onRequestClose={() => setOpenModal(false)}>
				<ModalHeader>
					<CloseButton
						src="/bradescoclassic/assets/icon-close.png"
						onClick={() => setOpenModal(false)}
					/>
				</ModalHeader>
				<div>
					{terms.content &&
						terms.content?.map(term => (

							<Line key={term}>
								{term.content.map(({ value, marks }) => {
									const className = !!marks
										? marks.map(mark => mark.type).join(' ')
										: ''
									return <TextBlock key={marks} className={className} dangerouslySetInnerHTML={{__html: value}}></TextBlock>
								})}
							</Line>
						))}
				</div>
			</ReactModal>
		</>
	)
}

export default Footer
